export const CategoriesMenuHandler = (function () {
    const _config = {
        dataParentCategory: 'data-parent-category',
        dataChildrenCategory: 'data-children-category',
        chevron: '.chevron'
    };

    const init = () => {
        document.querySelector('body').addEventListener('click', (e) => {
            const titleElement = e.target.closest('[' + _config.dataParentCategory + ']');
            if (titleElement) {
                _handleTitleClick(e, titleElement);
                // Prevents reload from clicking A tag
                e.preventDefault();
            }
        });
    };

    const _handleTitleClick = (e, titleElement) => {
        const parentCategory = titleElement.getAttribute(_config.dataParentCategory);
        const childrenContent = document.querySelector('[' + _config.dataChildrenCategory + '=' + parentCategory + ']');
        const chevron = titleElement.querySelector(_config.chevron);

        if (childrenContent) {
            if (childrenContent.style.maxHeight) {
                childrenContent.style.maxHeight = null;

                if (chevron) {
                    chevron.innerHTML = '-';
                }
            } else {
                childrenContent.style.maxHeight = '0px';
                if (chevron) {
                    chevron.innerHTML = '+';
                }
            }
        }
    };

    return {
        init: init
    };
})();
